export const featureConstant = {
	ACTIVITY_LOG_ENHANCEMENT: "ACTIVITY_LOG_ENHANCEMENT",
	NEW_DESIGN_SYSTEM: "NEW_DESIGN_SYSTEM",
	ONBOARDING_V2: "ONBOARDING_V2",
	DATA_ELEMENT_CENTRIC_NOTIFICATION: "DATA_ELEMENT_CENTRIC_NOTIFICATION",
	AGENT_PRINCIPAL_PHASE_2: "AGENT_PRINCIPAL_PHASE_2",
	MULTIDEX: "MULTIDEX",
	BUILDEX_GO_LIVE: "BUILDEX_GO_LIVE",
	ETR_LOGO_RENDERER: "ETR_LOGO_RENDERER",
	IG_PNI_LEGAL_REQUIREMENTS: "IG_PNI_LEGAL_REQUIREMENTS",
	EMAIL_PREFERENCE: "EMAIL_PREFERENCE",
	IG_PNI_TOKEN_REGISTRY: "IG_PNI_TOKEN_REGISTRY",
	SOFT_DELETE_USER: "SOFT_DELETE_USER",
	USER_ACCESS_MANAGEMENT_PHASE_2: "USER_ACCESS_MANAGEMENT_PHASE_2",
	ENABLE_COPY_TRANSACTION: "ENABLE_COPY_TRANSACTION",
	DSV_ENABLED: "DSV_ENABLED"
}

export const featureFlag = {
	[featureConstant.DATA_ELEMENT_CENTRIC_NOTIFICATION]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": false,
		"pre-prod": false,
		"buildex-dev": true,
		"buildex-prod": true,
		"prod": false
	},
	[featureConstant.ACTIVITY_LOG_ENHANCEMENT]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": false,
		"pre-prod": false,
		"buildex-dev": false,
		"buildex-prod": false,
		"prod": false
	},
	[featureConstant.AGENT_PRINCIPAL_PHASE_2]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": true,
		"pre-prod": true,
		"buildex-dev": false,
		"buildex-prod": false,
		"prod": true
	},
	[featureConstant.MULTIDEX]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": true,
		"pre-prod": true,
		"prod": false
	},
	[featureConstant.ETR_LOGO_RENDERER]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": true,
		"pre-prod": true,
		"buildex-dev": false,
		"buildex-prod": false,
		"prod": true
	},
	[featureConstant.IG_PNI_LEGAL_REQUIREMENTS]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": true,
		"pre-prod": true,
		"buildex-dev": false,
		"buildex-prod": false,
		"prod": true
	},
	[featureConstant.EMAIL_PREFERENCE]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": false,
		"pre-prod": false,
		"buildex-dev": true,
		"buildex-prod": false,
		"prod": false
	},
	[featureConstant.IG_PNI_TOKEN_REGISTRY]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": true,
		"pre-prod": true,
		"buildex-dev": false,
		"buildex-prod": false,
		"prod": true
	},
	[featureConstant.SOFT_DELETE_USER]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": false,
		"pre-prod": false,
		"buildex-dev": false,
		"buildex-prod": false,
		"prod": false
	},
	[featureConstant.USER_ACCESS_MANAGEMENT_PHASE_2]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": false,
		"pre-prod": false,
		"buildex-dev": true,
		"buildex-prod": false,
		"prod": false
	},
	[featureConstant.ENABLE_COPY_TRANSACTION]: {
		"local": true,
		"dev": true,
		"test": true,
		"uat": false,
		"pre-prod": false,
		"buildex-dev": false,
		"buildex-prod": false,
		"prod": false
	}
}
